import { merge } from 'lodash'
import { PublicationListingFragment } from '@sketch/gql-types'

const DEFAULT_LISTING_DATA: PublicationListingFragment = {
  __typename: 'PublicationListing' as const,
  title: '',
  preferences: {
    __typename: 'PublicationQueryPreferences' as const,
    allowPagination: null,
    identifiers: null,
    limit: null,
    search: null,
    sort: null,
    period: null,
  },
}

/**
 * Validate the response from the listingData
 * and make sure it matches the apollo expected response
 */
export const normalizeListingData = (data: any) => {
  return merge(DEFAULT_LISTING_DATA, data)
}
